import { render } from "./Creatives.vue?vue&type=template&id=674423fa&scoped=true"
import script from "./Creatives.vue?vue&type=script&lang=js"
export * from "./Creatives.vue?vue&type=script&lang=js"

import "./Creatives.vue?vue&type=style&index=0&id=674423fa&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-674423fa"]])

export default __exports__